module.exports = __webpack_public_path__ + "static/media/elevation.898446dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/yelp/src/elevation.png
// module id = 660
// module chunks = 0